import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { EPaymentModalType } from 'reactApp/components/VkBuyModalWithSidebar/VkBuyModalWithSidebar.types';
import { updateProducts } from 'reactApp/modules/products/products.module';
import { updateUser } from 'reactApp/modules/user/user.thunkActions';
import { sendGa } from 'reactApp/utils/ga';
import { EPaymentGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

export const useModalCallbacks = ({ onClose, product, type, onSuccess }) => {
    const dispatch = useDispatch();

    const sendModalGa = useCallback(
        (action) => {
            sendGa(`payment-vk-${type}`, action);

            if (type === EPaymentModalType.trial) {
                sendPaymentGa({ action: EPaymentGa.trialWindow, label: action, tariff: product?.id, amount: product?.discountPrice });
            } else if (type === EPaymentModalType.fastcheckout) {
                sendPaymentGa({
                    action: EPaymentGa.fastCheckout,
                    label: action,
                    tariff: product?.id,
                    type_page: product?.hasDiscount ? 'promo' : 'common',
                });
            } else if (type === EPaymentModalType.saveSubscription) {
                sendPaymentGa({
                    action: product?.isTransit ? EPaymentGa.saveSubsTransit : EPaymentGa.saveSubs,
                    label: action,
                    tariff: product?.id,
                });
            } else if (type === EPaymentModalType.attachesTrial) {
                sendPaymentGa({
                    action: EPaymentGa.attachesTrial,
                    label: action,
                    tariff: product?.id,
                });
            }
        },
        [product?.discountPrice, product?.hasDiscount, product?.id, product?.isTransit, type]
    );

    const onCloseModal = useCallback(() => {
        sendModalGa('close');
        onClose();
    }, [onClose, sendModalGa]);

    const onShow = useCallback(() => {
        sendModalGa('view');
    }, [sendModalGa]);

    const onCancel = useCallback(() => {
        sendModalGa('cancel');
    }, [sendModalGa]);

    const onDmrFormSend = useCallback(() => {
        sendModalGa(type === EPaymentModalType.fastcheckout ? 'click_pay' : 'click');
    }, [sendModalGa, type]);

    const onSuccessCallback = useCallback(() => {
        sendModalGa('success');

        if (onSuccess) {
            onSuccess();
        } else {
            dispatch(updateProducts());
            dispatch(updateUser());
        }
    }, [dispatch, onSuccess, sendModalGa]);

    const onClickTariffs = useCallback(() => {
        sendModalGa('click_more');
    }, [sendModalGa]);

    return {
        onCloseModal,
        onCancel,
        onShow,
        onDmrFormSend,
        onSuccessCallback,
        onClickTariffs,
    };
};
